<template>
	<el-container style="background: #101010;display: block;padding-top: 60px;">
		<div class="container" style="padding-bottom: 60px;">
      <el-footer height="auto">
      	<div class="left">
      		<div class="text">
      			<h4 style="color: #FFFFFF;">{{$t('corp.name')}}</h4>
      			<p>{{$t('corp.address')}}</p>
      			<p>{{$t('corp.Telephone')}}</p>
      			<p>{{$t('corp.Email')}}</p>
      		</div>
      		<div class="icon">
						<a target="_blank" id="QQ" href="javascript:;" @click="qqchat()">
							<span class="iconfont">&#xe6af;</span>
						</a>
						<a href="javascript:;">
							<span class="iconfont">&#xe933;</span>
							<div class="code"><img src="../../assets/wechatcode.jpg" alt=""></div>
						</a>
            <div @click="lang"><i :class="language? 'active' :''">中</i>/<i :class="!language? 'active' :''">EN</i></div>
      		</div>
      	</div>
      	<ul class="right">
      		<li v-for="item in $t('menu.bottom')">
      			<span>{{item.title}}</span>
						<div>
							<router-link v-for="i in item.url" :to="i.href" :key="i.index">{{i.name}}</router-link>
						</div>
      		</li>

      	</ul>
      </el-footer>
    </div>
		<div class="bottom">
			<div class="container footer">
				<p>CopyRight 2020 All Right Reserved 佛山一鼎吉包装技有限公司 <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备20032865号-1</a></p>
			</div>
		</div>
	</el-container>
</template>

<script>
export default {
	name: 'bottom',
	data() {
		return {
      language: true,
		};
	},
  mounted(){
    var language = sessionStorage.getItem('language');
    if(language != 'null'&& language != null){
    	this.language = false;
    };
  },
  methods:{
    lang () {
      var lang = this.language;
      if(lang){
        sessionStorage.setItem('language','en');
        sessionStorage.setItem('locale','en');
      }else{
        sessionStorage.setItem('language',null);
        sessionStorage.setItem('locale','cn');
      }
    	//this.$i18n.locale = 'cn';
    	location.reload();
    },
    qqchat(){
    	var ua = window.navigator.userAgent.toLowerCase();
    	if(ua.match(/MicroMessenger/i) == 'micromessenger'){
    		window.open('http://wpa.qq.com/msgrd?v=3&uin=2352221613&site=qq&menu=yes');
    	}else{
    		window.open('mqqwpa://im/chat?chat_type=wpa&uin=2352221613&version=1&src_type=web&web_src=oicqzone.com');
    	}
    },
  }
}
</script>

<style>
.el-footer{
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	padding: 0;
  padding-bottom: 0;
}
.el-footer .left{
	width: 40%;
}
.el-footer .left h4{
	text-align: left;
	font-size: 20px;
	margin-top: 0;
	margin-bottom: 20px;
}
.el-footer .left p{
	text-align: left;
	font-size: 14px;
	margin-bottom: 5px;
	color: #999;
}
.el-footer .left .icon{
	display: flex;
	margin-top: 30px;
	position: relative;
}
.el-footer .left .icon a{
	display: block;
	border: 1px solid #8a8a8a;
	border-radius: 50%;
	margin-right: 10px;
	position: relative;
	width: 40px;
	height: 40px;
	text-decoration: none;
	transition: all .3s ease;
}
.el-footer .left .icon a .code{
	padding: 10px;
	box-sizing: border-box;
	background: #e0e0e0;
	position: absolute;
	width: 180px;
	top: -190px;
	left: -70px;
	opacity: 0;
	transition: all .3s ease;
  visibility: hidden;
}
.el-footer .left .icon a .code::after{
	content: '';
	border: 8px solid rgba(0,0,0,0);
	position: absolute;
	top: 182px;
	left: 50%;
	transform: translateX(-50%);
	border-top-color: #e0e0e0;
}
.el-footer .left .icon a span{
	font-size: 18px;
	color: #fff;
	line-height: 40px;
	text-align: center;
	display: block;
	transition: all .3s ease;
}
.el-footer .left .icon a:hover{
	background-color: #fff;
}
.el-footer .left .icon a:hover span{
	color: #000;
}
.el-footer .left .icon a:hover .code{
  top: -200px;
	opacity: 1;
  visibility: visible;
}
.el-footer .left .icon>div{
  position: absolute;
  top: 8px;
  right: 0;
  color: #fff;
  padding: 2px 10px;
  border: 1px solid #8a8a8a;
  display: none;
}
.el-footer .left .icon div i{
  color: #fff;
  font-style: normal;
}
.el-footer .left .icon div i.active{
  color: #ff9d45;
}
.el-footer .right{
	width: 50%;
	display: flex;
	justify-content: space-between;
}
.el-footer .right li{
	margin: 0;
}
.el-footer .right span{
  color: #FFFFFF;
	margin-bottom: 20px;
	text-align: center;
	display: block;
}
.el-footer .right a{
	font-size: 14px;
	margin: 0;
	text-align: left;
	text-decoration: none;
	margin-bottom: 10px;
	color: #999;
	display: block;
}
.bottom{
	width: 100%;
	padding: 20px 0;
	background-color: #1d1d1d;
}
.bottom p{
	text-align: center;
	font-size: 12px;
	color: #999;
}
.bottom a{
  color: #999;
  text-decoration: none;
}
@media (max-width: 992px){
  .el-footer .left{
    width: 100%;
  }
  .el-footer .left .icon div{
    display: block;
  }
  .el-footer .right{
    width: 100%;
    margin-top: 20px;
		flex-wrap: wrap;
  }
	.el-footer .right li{
		display: block;
		width: 100%;
	}
	.el-footer .right span{
		margin: 0;
		padding: 15px 0;
		border-bottom: 1px solid #d4d4d4;
	}
	.el-footer .right div{
		height: 0;
		overflow: hidden;
		transition: all .3s ease;
	}
	.el-footer .right a{
		text-align: center;
		margin-top: 10px;
	}
	.el-footer .right li:hover div{
		height: 68px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/bottom.vue